var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistoryEduFill0Wght400Grad0Opsz48(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.05 40q-1.2 0-2.1-.9-.9-.9-.9-2.1v-5h6.2v-6.35q-1.9.15-3.8-.525T12.05 23v-2.9h-2.5L3 13.55q1.8-1.7 4.3-2.775T12.4 9.7q1.5 0 3.425.475 1.925.475 3.425 1.525V8H42v26.75q0 2.2-1.525 3.725T36.75 40Zm6.2-8H34.5v2.75q0 1 .625 1.625T36.75 37q1 0 1.625-.625T39 34.75V11H22.25v2.85L34.3 25.9v2.15h-2.15l-6.3-6.3-.85 1q-.65.75-1.3 1.15-.65.4-1.45.75ZM10.9 17.1h4.15v4.45q.85.55 1.675.825.825.275 1.675.275 1.25 0 2.55-.675 1.3-.675 1.9-1.375l.85-1-3.45-3.45q-1.6-1.6-3.6-2.525-2-.925-4.25-.925-1.35 0-2.45.325T7.7 13.9ZM31.5 35H16.05v2H32.2q-.3-.3-.5-.825-.2-.525-.2-1.175Zm-15.45 2v-2 2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryEduFill0Wght400Grad0Opsz48);
export default __webpack_public_path__ + "static/media/history_edu_FILL0_wght400_GRAD0_opsz48.e1333d6813f8ac9a8aed3a816b126653.svg";
export { ForwardRef as ReactComponent };